// import { toast } from 'react-toastify';
import { Types } from '../reducers/institutions';
import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import * as serverRoutes from 'utils/consts/serverRoutes.js';

// Asynchronous

// Synchronous
export const createInstitution = (institutionData, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.post(serverRoutes.Institutions.crud(), institutionData)
      .then((response) => {
        dispatch({
          type: Types.CREATE_INSTITUTIONS,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        callback(false, err?.response?.data);
        console.log(err, err?.response?.data)
      })
  }
}

export const getInstitutions = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.Institutions.crud('', { page, limit, query, sort }))
      .then((response) => {
        dispatch({
          type: Types.GET_PAGED_INSTITUTIONS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_PAGED_INSTITUTIONS,
          payload: []
        });
      })
  }
}

export const getAllInstitutions = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.Institutions.getAll)
      .then((response) => {
        dispatch({
          type: Types.GET_INSTITUTIONS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_INSTITUTIONS,
          payload: []
        });
      })
  }
}

export const getAllExternalInstitutions = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.Institutions.getAllExternal)
      .then((response) => {
        dispatch({
          type: Types.GET_EXTERNAL_INSTITUTIONS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_EXTERNAL_INSTITUTIONS,
          payload: []
        });
      })
  }
}

export const getAllInternalInstitutions = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.Institutions.getAllInternal)
      .then((response) => {
        dispatch({
          type: Types.GET_INTERNAL_INSTITUTIONS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_INTERNAL_INSTITUTIONS,
          payload: []
        });
      })
  }
}

export const getInstitution = (institutionId) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.Institutions.crud(`/${institutionId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_INSTITUTION,
          payload: response.data
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_INSTITUTION,
          payload: null,
        })
      })
  }
}

export const updateInstitution = (institutionId, institutionData, callback) => {
  return (dispatch) => {
    axiosInstance.put(serverRoutes.Institutions.crud(`/${institutionId}`), institutionData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_INSTITUTION,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        callback(false, err?.response?.data);
        console.log(err, err?.response?.data)
      });
  }
}

export const deleteInstitution = (institutionCode, callback) => {
  return (dispatch) => {
    axiosInstance.delete(serverRoutes.Institutions.crud(`/${institutionCode}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_INSTITUTION,
          payload: response.data
        });
        callback(true, response.data.message);
      })
      .catch((err) => {
        console.log(err)
        const message = err?.response?.data.error || 'Erro ao inativar instituição.';
        callback(false, message);
      })
  }
}

export const reactivateInstitution = (institutionCode, callback) => {
  return (dispatch) => {
    axiosInstance.put(serverRoutes.Institutions.reactivate(`/${institutionCode}`))
      .then((response) => {
        dispatch({
          type: Types.REACTIVATE_INSTITUTION,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err)
        callback(false);
      })
  }
}
